import { Pipe, PipeTransform } from '@angular/core';
import { AssignmentsDTO } from './assignment.model';
import { AssignmentFilterParam } from './assignment-filter-param';

@Pipe({
  name: 'assignmentFilter'
})
export class AssignmentFilterPipe implements PipeTransform {

  transform(data: AssignmentsDTO[], filter: AssignmentFilterParam): AssignmentsDTO[] {
    return data.filter(
      x =>
      (!filter.FromDueDate || new Date(x.DueDate) >= filter.FromDueDate)
      && (!filter.ToDueDate || new Date(x.DueDate) <= filter.ToDueDate)
      && (!filter.FromAssignedDate || new Date(x.AssignedDate) >= filter.FromAssignedDate)
      && (!filter.ToAssignedDate || new Date(x.AssignedDate) <= filter.ToAssignedDate)
      && (!filter.FromPercentage || (x.Percentage) >= filter.FromPercentage)
      && (!filter.ToPercentage || (x.Percentage) <= filter.ToPercentage)
      && (!filter.Category || x.Category.toLowerCase().startsWith(filter.Category.toLowerCase()) || (filter.Category.startsWith('%') && x.Category.toLowerCase().indexOf(filter.Category.toLowerCase().substring(1)) > -1))
      && (!filter.Grade || x.Grade.toLowerCase().startsWith(filter.Grade.toLowerCase()) || (filter.Grade.startsWith('%') && x.Grade.toLowerCase().indexOf(filter.Grade.toLowerCase().substring(1)) > -1))
      && (!filter.Course ||  x.Course === filter.Course)
      && (!filter.Term || x.Term === filter.Term)
    );
  }

}
